import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import {
  AGENT_NAMES,
  ATV_STATUS_LIST,
  BIKE_PRODUCTS,
  GUEST_NAMES,
} from "pages/transaksi/booking/components/Constants";
import { getRandomNum } from "../utils/utils";
import { getRequest } from "services/api";
import { buildQueryString } from "utils/queryHelpers";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { useTrip } from "./v1/masterData/TripContext";
import { debounce } from "lodash";

// Membuat context untuk loading
const BookingContext = createContext();

// Helper function to generate bookings with more realistic names
const generateBookings = (num) => {
  return Array.from({ length: num }, (_, i) => ({
    id: `KBA ${i + 1090}`,
    name: getRandomNum(GUEST_NAMES),
    guest: 0, // 1 to 5 guests
    bike: 0, // 1 to 3 bikes
    agent: getRandomNum(AGENT_NAMES),
    status: getRandomNum(ATV_STATUS_LIST),
    // status: ATV_STATUS_LIST[0],
    product: [getRandomNum(BIKE_PRODUCTS)],
    price: getRandomNum(BIKE_PRODUCTS).price,
  }));
};

// Provider untuk context loading
export const BookingProvider = ({ children }) => {
  const {
    trips,
    fetchTripsAvailable,
    fetchTrips,
    updateFilterTrip,
    setFilterOptionsTrip,
  } = useTrip();

  const [bookings, setBookings] = useState({
    data: [],
    loading: false,
    pagination: null,
    error: null,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
    filters: {
      id: "",
      // reservation_date: "", // Set tanggal untuk testing auto set hari ini
      reservation_date: new Date().toISOString().split("T")[0], // Set tanggal hari ini
      code: "",
      trip_id: "",
      agent_id: "",
      customer_id: "",
      label_id: "",
      mode: "",
      status: "",
      guest_name: "",
    },
  });

  const initialSessionsVOld = trips.data.map((trip) => {
    // Jika activities tidak ada, default ke array kosong
    const atvQty = (trip.activities || [])
      .filter((activity) => activity.activity.includes("ATV")) // Filter aktivitas yang berhubungan dengan ATV
      .reduce((total, activity) => total + activity.qty, 0); // Hitung total qty

    return {
      ...trip,
      id: trip.id,
      title: trip.name,
      time: trip.start_time + " - " + trip.end_time,
      stocks: {
        stocks: trip.availability,
        booking: trip.total_reserved_atv,
        arrived: trip.total_reserved_atv_confirmed,
        in_track: trip.remaining,
      },
      date: filterOptions.filters.reservation_date,
      // bookings: generateBookings(0), // Dummy bookings
      bg_trip:
        trip.name === "Trip 1"
          ? "bg-yellow-lt"
          : trip.name === "Trip 2"
          ? "bg-purple-lt"
          : trip.name === "Trip 3"
          ? "bg-blue-lt"
          : trip.name === "Trip 4"
          ? "bg-green-lt"
          : trip.name === "Trip 5"
          ? "bg-red-lt"
          : "bg-secondary-lt", // Default warna
      atvQty, // Tambahkan total ATV qty ke setiap session
    };
  });
  const [dataPerTrip, setDataPerTrip] = useState({});

  const initialSessions = trips.data.map((trip) => {
    // Hitung statistik dari data booking yang difilter berdasarkan trip_id
    // console.log("intialSessions", trip);
    const bookingsForTrip = dataPerTrip[trip.id] || [];

    const totalBooking = bookingsForTrip.length;
    const totalArrived = bookingsForTrip.filter(
      (booking) => booking.status === "arrived"
    ).length;
    const totalInTrack = bookingsForTrip.filter(
      (booking) => booking.status === "in_track"
    ).length;

    return {
      ...trip,
      id: trip.id,
      title: trip.name,
      time: trip.start_time + " - " + trip.end_time,
      stocks: {
        stocks: trip.availability, // Total stok dari trip
        booking: trip.total_reserved,
        arrived: trip.total_confirmed,
        in_track: trip.remaining,
        // booking: totalBooking, // Total booking untuk trip ini
        // arrived: totalArrived, // Total tamu yang sudah arrived
        // in_track: totalInTrack, // Total tamu yang in_track
      },
      date: filterOptions.filters.reservation_date,
      bg_trip:
        trip.name === "Trip 1"
          ? "bg-yellow-lt"
          : trip.name === "Trip 2"
          ? "bg-purple-lt"
          : trip.name === "Trip 3"
          ? "bg-blue-lt"
          : trip.name === "Trip 4"
          ? "bg-green-lt"
          : trip.name === "Trip 5"
          ? "bg-red-lt"
          : "bg-secondary-lt", // Default warna
    };
  });

  const queryString = buildQueryString({
    search: filterOptions.search || "",
    page: filterOptions.currentPage,
    // limit: LIMIT_DATA_PER_PAGE,
    limit: 100,
    include: "activities", // Tambahkan include untuk memuat relasi activities
  });

  const buildFilterString = (filters) => {
    const filterEntries = Object.entries(filters)
      .filter(([_, value]) => value !== "") // Hanya menyertakan filter yang memiliki nilai
      .map(([key, value]) => `filter[${key}]=${value}`);
    return filterEntries.join("&");
  };

  const updateFilter = (key, value) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [key]: value, // Perbarui reservation_date dengan nilai baru
      },
    }));
    // Jika yang diupdate adalah reservation_date, sinkronkan dengan TripContext
    if (key === "reservation_date") {
      updateFilterTrip("date", value); // Panggil fungsi updateFilter dari TripContext
    }
  };

  // const handleSearch = (e) => {
  //   if (e.key === "Enter") {
  //     console.log("search", e.target.value);

  //     if (e.target.value.trim() === "") {
  //       // Reset filter jika input kosong
  //       setFilterOptions((prevState) => ({
  //         ...prevState,
  //         search: "", // Reset pencarian ke default kosong
  //       }));
  //     } else {
  //       // Perbarui filter pencarian
  //       setFilterOptions((prevState) => ({
  //         ...prevState,
  //         search: e.target.value,
  //       }));
  //     }
  //   }
  // };


const handleSearchDebounced = debounce((value) => {
  setFilterOptions((prevState) => ({
    ...prevState,
    search: value,
  }));
}, 300); // Tunda 300ms

const handleSearch = (e) => {
  if (e.key === "Enter") {
    handleSearchDebounced(e.target.value);
  }
};


  const fetchBookings = useCallback(async () => {
    setBookings((prevState) => ({
      ...prevState,
      loading: true,
    }));

    // Tambahkan filter reservation_date jika ada
    const reservationDateFilter = filterOptions.filters.reservation_date || "";
    // const reservationDateFilter = filterOptions.filters.reservation_date;
    const agentIdFilter = filterOptions.filters.agent_id; // Ambil nilai agent_id dari state
    const labelIdFilter = filterOptions.filters.label_id; // Ambil nilai label_id dari state
    const statusFilter = filterOptions.filters.status; // Ambil nilai status dari state

    // Build query string dengan filter reservation_date
    const queryStringWithFilter = buildQueryString({
      search: filterOptions.search || "",
      page: filterOptions.currentPage,
      // limit: LIMIT_DATA_PER_PAGE,
      limit: 1000,
      [`filter[reservation_date]`]: reservationDateFilter,
      ...(agentIdFilter && { [`filter[agent_id]`]: agentIdFilter }), // Tambahkan jika ada nilai
      ...(labelIdFilter && { [`filter[label_id]`]: labelIdFilter }), // Tambahkan jika ada nilai
      ...(statusFilter && { [`filter[status]`]: statusFilter }), // Tambahkan jika ada nilai
      // "include": "activities",
      include: "activities,count_logs", // Tambahkan include untuk memuat relasi activities
    });

    try {
      const response = await getRequest(`/reservation${queryStringWithFilter}`);
      if (response.success) {
        const rawData = response.data;

        // Kelompokkan data per trip
        const groupedByTrip = rawData.reduce((acc, item) => {
          const tripId = item.trip_id || "Unknown Trip"; // Default jika `trip_id` kosong
          if (!acc[tripId]) {
            acc[tripId] = [];
          }
          acc[tripId].push(item);
          return acc;
        }, {});

        // Simpan data ke state
        setDataPerTrip(groupedByTrip);

        setBookings({
          data: rawData,
          pagination: response.pagination,
          error: null,
          loading: false,
        });

        // Console log hasil yang dikelompokkan
        // console.log("Data grouped by trip:", groupedByTrip);
      }
    } catch (error) {
      setBookings((prevState) => ({
        ...prevState,
        error: "Failed to fetch reservation",
        loading: false,
      }));
      console.error("Error fetching reservations:", error);
    }
  }, [filterOptions]);

  // useEffect(() => {
  //   fetchBookings();
  // }, [fetchBookings]);

  // useEffect(() => {
  //   fetchTripsAvailable(); // Ambil data trip berdasarkan tanggal terbaru
  //   fetchBookings(); // Ambil data booking berdasarkan tanggal terbaru
  // }, [filterOptions.filters.reservation_date]); // Trigger saat tanggal berubah
  // useEffect(() => {
  //   fetchBookings(); // Panggil ulang API saat search berubah
  // }, [filterOptions.search]);
  // useEffect(() => {
  //   fetchBookings();
  // }, [filterOptions.filters.agent_id]);
  // useEffect(() => {
  //   fetchBookings();
  // }, [filterOptions.filters.label_id]);
  // useEffect(() => {
  //   fetchBookings();
  // }, [filterOptions.filters.status]);

  useEffect(() => {
    fetchBookings(); // Hanya satu pemanggilan API
  }, [
    filterOptions.search,
    filterOptions.filters.reservation_date,
    filterOptions.filters.agent_id,
    filterOptions.filters.label_id,
    filterOptions.filters.status,
  ]);
  

  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isOpenCanvas, setIsOpenCanvas] = useState(false);

  return (
    <BookingContext.Provider
      value={{
        sessions: initialSessions,
        // setSessions,
        isOpenCanvas,
        setIsOpenCanvas,
        selectedBooking,
        setSelectedBooking,
        bookings,
        filterOptions,
        updateFilter,
        handleSearch,
        dataPerTrip,
        refetch: fetchBookings,
        // trips: trips,
        trips: trips,
        // refetch: fetchTrips,
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};

// Hook untuk mengakses context loading
export const useApp = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error("useApp must be used within a BookingProvider");
  }
  return context;
};
